export default function PrivacyPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#050510', padding: '80px 24px', color: '#f0f0ff' }}>
      <div style={{ maxWidth: 680, margin: '0 auto' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, marginBottom: 24 }}>Privacy Policy</h1>
        <p style={{ color: '#8888aa', fontSize: 14, lineHeight: 1.8, marginBottom: 16 }}>
          Last updated: March 2026
        </p>
        <div style={{ color: '#8888aa', fontSize: 14, lineHeight: 1.8 }}>
          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>1. Information We Collect</h2>
          <p>We collect information you provide directly: email address, name, and startup idea details you submit through the pipeline. We also collect usage data such as pages visited and features used.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>2. How We Use Your Information</h2>
          <p>Your information is used to provide and improve the Service, generate AI-powered analysis, process payments, and communicate with you about your account.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>3. Data Security</h2>
          <p>We implement industry-standard security measures to protect your data. Your startup ideas are private and never shared with other users or third parties for marketing purposes.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>4. AI Processing</h2>
          <p>Your idea descriptions are processed by AI models to generate analysis. This data is not used to train AI models and is processed only for your benefit.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>5. Third-Party Services</h2>
          <p>We use third-party services for payment processing (Stripe), authentication, and AI analysis. These services have their own privacy policies.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>6. Your Rights</h2>
          <p>You can request access to, correction of, or deletion of your personal data at any time by contacting us.</p>

          <h2 style={{ color: '#f0f0ff', fontSize: 18, fontWeight: 700, marginTop: 28, marginBottom: 12 }}>7. Contact</h2>
          <p>For privacy concerns, contact us at privacy@startupscore.live.</p>
        </div>
      </div>
    </div>
  );
}
